import { render, staticRenderFns } from "./PcNews3.vue?vue&type=template&id=5714cdaf&scoped=true"
import script from "./PcNews3.vue?vue&type=script&lang=js"
export * from "./PcNews3.vue?vue&type=script&lang=js"
import style0 from "./PcNews3.vue?vue&type=style&index=0&id=5714cdaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5714cdaf",
  null
  
)

export default component.exports